"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.copy = exports.empty = exports.new_from = exports.ravel = exports.reshape = exports.parse_shape = exports.shape_shifts = exports.as_number = exports.as_boolean = exports.number_collapse = exports._NDArray = exports.new_NDArray = exports.array = exports.asarray = exports.isarray = void 0;
var _globals_1 = require("./_globals");
Object.defineProperty(exports, "isarray", { enumerable: true, get: function () { return _globals_1.isarray; } });
Object.defineProperty(exports, "asarray", { enumerable: true, get: function () { return _globals_1.asarray; } });
Object.defineProperty(exports, "array", { enumerable: true, get: function () { return _globals_1.array; } });
Object.defineProperty(exports, "new_NDArray", { enumerable: true, get: function () { return _globals_1.new_NDArray; } });
Object.defineProperty(exports, "_NDArray", { enumerable: true, get: function () { return _globals_1._NDArray; } });
// Functions to avoid importing NDArray (because if I import NDArray, I can't use it as a type annotation in the same file)
/**
 * If the array is 0D, it returns it's unique element (number or boolean).
 * The signature is kept as NDArray for type consistency, even though the
 * output is a number or a boolean. This is consistent with the facts that
 * (1) all functions requiring arrays work with numbers as well because they call asarray,
 * and (2) semantically, a constant is an array.
 */
function number_collapse(arr, expect) {
    if (expect === void 0) { expect = false; }
    if (!arr.shape.length)
        return arr.flat[0];
    if (expect)
        throw new Error("Expected constant. Got array with shape ".concat(arr.shape));
    return arr;
}
exports.number_collapse = number_collapse;
function as_boolean(obj) {
    if ((0, _globals_1.isarray)(obj))
        obj = number_collapse(obj, true);
    else if (typeof obj == 'string')
        throw new Error("'string' object can not be interpreted as boolean: ".concat(obj));
    return !!(0 + obj);
}
exports.as_boolean = as_boolean;
function as_number(obj) {
    if ((0, _globals_1.isarray)(obj))
        obj = number_collapse(obj, true);
    else if (typeof obj == 'string')
        throw new Error("'string' object can not be interpreted as boolean: ".concat(obj));
    return parseFloat(obj);
}
exports.as_number = as_number;
// ====================
// Reshape and shape shifts for indexing
// ====================
function shape_shifts(shape) {
    // increasing one by one on a given axis is increasing by shifts[axis] in flat representation
    var shifts = Array.from({ length: shape.length }, function (_) { return 0; });
    shifts[shape.length - 1] = 1;
    for (var i = shape.length - 2; i >= 0; i--)
        shifts[i] = shifts[i + 1] * shape[i + 1];
    return shifts;
}
exports.shape_shifts = shape_shifts;
function parse_shape(list) {
    if (typeof list == "number")
        return [list];
    if ((0, _globals_1.isarray)(list)) {
        if (list.shape.length > 1) {
            throw new Error("Expected flat list. Got array with shape ".concat(list.shape));
        }
        return __spreadArray([], __read(list.flat), false);
    }
    if (Array.isArray(list))
        return list;
    throw new Error("Expected list. Got ".concat(list));
}
exports.parse_shape = parse_shape;
function reshape(A, shape_or_first) {
    var more_shape = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        more_shape[_i - 2] = arguments[_i];
    }
    A = (0, _globals_1.asarray)(A);
    var shape;
    if (!more_shape.length)
        shape = parse_shape(shape_or_first);
    else
        shape = __spreadArray([shape_or_first], __read(more_shape), false).map(as_number);
    var n = A.size;
    // Find -1
    var inferredIndex = shape.indexOf(-1);
    if (inferredIndex !== -1) {
        var known = shape.filter(function (dim) { return dim !== -1; }).reduce(function (acc, val) { return acc * val; }, 1);
        if (n % known !== 0) {
            throw new Error("Invalid shape. The total number of elements must match the product of the known dimensions.");
        }
        shape[inferredIndex] = n / known;
    }
    else {
        var m = shape.reduce(function (a, b) { return a * b; }, 1);
        if (n !== m) {
            throw new Error("Invalid target shape [".concat(shape, "] from source [").concat(A.shape, "]. Expected size ").concat(n, ". Found ").concat(m, "."));
        }
    }
    return (0, _globals_1.new_NDArray)(A.flat, shape);
}
exports.reshape = reshape;
;
function ravel(A) {
    A = (0, _globals_1.asarray)(A);
    return (0, _globals_1.new_NDArray)(A.flat, [A.size]);
}
exports.ravel = ravel;
;
// ====================
// Constructors
// ====================
function new_from(shape, f, dtype) {
    if (f === void 0) { f = undefined; }
    if (dtype === void 0) { dtype = Float32Array; }
    shape = parse_shape(shape);
    var size = shape.reduce(function (a, b) { return a * b; }, 1);
    //@ts-ignore
    var buffer = f === undefined ? new dtype(size) : dtype.from({ length: size }, f);
    return (0, _globals_1.new_NDArray)(buffer, shape);
}
exports.new_from = new_from;
;
function empty(shape, dtype) {
    if (dtype === void 0) { dtype = Float32Array; }
    return new_from(shape, undefined, dtype);
}
exports.empty = empty;
;
function copy(A) {
    return (0, _globals_1.new_NDArray)(A.dtype.from(A.flat), A.shape);
}
exports.copy = copy;
